import ProductCompareAPICall from "../service/ProductCompareAPICall";
import Helper from "../helper/Helper";
import store from "../storeWire";
import System from "../helper/system";
import { __set, __remove } from "src/store/axios_indicator";
import { loadData } from "src/store/slice/model/ProductCompare";
const { storageName: { PRODUCT_COMPARE } } = System
class ProductCompareRepository {

    fetchAllData = async () => {
        __set('PRODUCT_COMPARE_API_CALL');
        const res = await new ProductCompareAPICall().getAll();
        store.dispatch(loadData({
            data: res.data
        }));
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };

    toggleSingleProduct = async (data) => {
        let dataHere = {};
        const state = store.getState();
        if (state.entities.model_ProductCompare.data && Object.entries(state.entities.model_ProductCompare.data).length > 0) {
            dataHere = JSON.parse(JSON.stringify(state.entities.model_ProductCompare.data));
        }
        if (dataHere[data.ItemNumber] && dataHere[data.ItemNumber]) {
            delete dataHere[data.ItemNumber];
            const res = await new ProductCompareAPICall().setAll(dataHere);
            return res;
        } else {
            const dd = {
                ItemNumber: data.ItemNumber,
                ManufacturerPartNumber: data.ManufacturerPartNumber,
                ERPMFRPartNumber: data.ERPMFRPartNumber,
                // PartNumber: data.ERPMFRPartNumber,
                Quantity: data.QtyMin,
                QtyMin: data.QtyMin,
                QtyMult: data.QtyMult,
                DatasheetUrl: data.DatasheetUrl,
                Manufacturer: data.ManufacturerName,
                ManufacturerName: data.ManufacturerName,
                ItemRowNumber: data.ItemRowNumber,
                AssetURL: data.AssetURL,
                ERPManufacturerName: data.ERPManufacturerName,
                ObsoleteFlag: data.ObsoleteFlag,
                ERPManufacturerCode: data.ERPManufacturerCode,
                WebCode: data.WebCode,
                Attributes: data.Attributes,
                CustomerPartNumbers: data.CustomerPartNumbers,
                LifeCycleRisk: data.LifeCycleRisk,
                ROHSCompliantCodeValue: data.ROHSCompliantCodeValue,
                ROHSCompliantCode: data.ROHSCompliantCode,
                // PackagingTypeCode: data.PackagingTypeCode,
                WebOnlyFlag: data.WebOnlyFlag,
                NPIFlag: data.NPIFlag,
                TopSellerFlag: data.TopSellerFlag,
                EndOfLifeFlag: data.EndOfLifeFlag,
                ManufacturerCode: data.ManufacturerCode,
                NCNRFlag: data.NCNRFlag,
                IsDesignsAvailable: data.IsDesignsAvailable,
                ShortDescription: data.ShortDescription,
                StructureHierarchy: data.StructureHierarchy,
                FactoryLeadTime: data.FactoryLeadTime,
                SapPartNumber: data.SapPartNumber,
                distributor: data.distributor,
                default_plant: data.default_plant,
                exists_in_sap: data.exists_in_sap,
                factory_qoh: data.factory_qoh,
                Stock: data.Stock,
                VendorPartNumber: data.VendorPartNumber,
                isAvnetDistributor: data.isAvnetDistributor,
                isPartnerDistributor: data.isPartnerDistributor,
                isNewarkDistributor: data.isNewarkDistributor,
                MDMMaterialID: data.MDMMaterialID,
                sapTlaTypeCd: data.sapTlaTypeCd,
                PIMBlock: data.PIMBlock,
                AllocationFlag: data.AllocationFlag,
                specialPriceFlag: (data?.SAPMaterialPricingGroupCode?.toUpperCase() === 'SP' || data?.SAPMaterialPricingGroupCode?.toUpperCase() === 'EI') ? true : false,
                SoftwareDownloadFlag: data.SoftwareDownloadFlag,
                constrainPartFlag: data.constrainPartFlag,
                custom_reel_flag: data.custom_reel_flag,
                PackagingTypeCode: data.PackagingTypeCode,
                ERPPartNumber: data.ERPPartNumber
            };

            dataHere[data.ItemNumber] = dd;
        }
        if (Object.entries(dataHere).length >= 11) {
            return {};
        }
        const res = await new ProductCompareAPICall().setAll(dataHere);
        this.fetchAllData();
        return res;
    };

    getSessionUUID = () => {
        const c = System.getParams();
        if (c.productCompareUUID && c.productCompareUUID.length > 1) {
            return c.productCompareUUID;
        }
        return this.setUUIDOnKey('sessionUUID');
    };

    setValueToCompareProduct = (key, value) => {
        let CompareProduct = this.getCompareProduct()
        CompareProduct[key] = value;
        localStorage.setItem(PRODUCT_COMPARE, JSON.stringify(CompareProduct));
        return this.getValueFromCompareProduct(key);
    };

    setUUIDOnKey = (key) => {
        let l = this.getValueFromCompareProduct(key);
        if (l) {
            return l;
        }
        l = Helper.UUID();
        return this.setValueToCompareProduct(key, l);
    };

    getValueFromCompareProduct = (key) => {
        const l = this.getCompareProduct([key]);
        if (l[key] === undefined) {
            return false;
        }
        return l[key];
    };

    getCompareProduct = () => {
        let CompareProduct = localStorage.getItem(PRODUCT_COMPARE);
        if (CompareProduct) {
            CompareProduct = JSON.parse(CompareProduct);
        } else {
            CompareProduct = {}
        }
        return CompareProduct;
    };
}

export default ProductCompareRepository;